<template>
  <v-card class="card-pad">
    <v-dialog v-model="addPointModal" max-width="400">
      <v-card class="pa-4" :key="addPointModalKey">
        <h2 class="text-center">{{ $t('Adicionar ponto de consumo') }}</h2>

        <v-form ref="form2" class="mt-4 px-3">
          <v-text-field
            v-model="point.name"
            class="primary-input"
            :placeholder="$t('Insira um nome')"
            :rules="[(v) => !!v || 'Ponto de consumo obrigatório']"
            outlined
            hide-details="auto"
          ></v-text-field>

          <v-autocomplete
            loading="unidadeLoading"
            :items="unidades"
            item-text="name"
            item-value="id"
            v-model="point.unidadeId"
            class="primary-input"
            :placeholder="$t('Selecione a unidade')"
            :rules="[(v) => !!v || 'Unidade obrigatório']"
            outlined
            hide-details="auto"
          ></v-autocomplete>

          <v-autocomplete
            loading="unidadeLoading"
            :items="[
              { name: 'Soma', value: 0 },
              { name: 'Subtração', value: 1 },
            ]"
            item-text="name"
            item-value="value"
            v-model="point.measurementMethodology"
            class="primary-input"
            :placeholder="$t('Metodologia de medição')"
            :rules="[(v) => v != null || 'Metodologia obrigatório']"
            outlined
            hide-details="auto"
          ></v-autocomplete>
        </v-form>

        <div class="d-flex justify-center">
          <v-btn
            depressed
            class="primary-button ma-1"
            width="45%"
            @click="addPointModal = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>
          <v-btn
            depressed
            width="45%"
            class="secondary-button ma-1"
            @click="addPoint"
          >
            {{ $t('Salvar') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-toolbar flat class="back">
      <v-btn small plain color="grey" @click="$router.back()">
        <v-icon x-small class="mr-1">mdi-chevron-left</v-icon>
        {{ $t('Voltar') }}
      </v-btn>
    </v-toolbar>

    <v-toolbar flat class="mb-5 back">
      <div class="d-flex align-end">
        <div id="iconTitle">
          <v-icon id="icon" size="30px" color="white">
            mdi-archive-check-outline
          </v-icon>
        </div>

        <v-toolbar-title>{{ $t('Cadastrar Tipo') }}</v-toolbar-title>
      </div>
    </v-toolbar>

    <v-card class="card pa-2 mx-4 my-8">
      <v-form ref="form">
        <v-row class="ma-0 mt-4" dense>
          <v-col cols="12" sm="3">
            <span class="text ml-1">{{ $t('Nome') }}</span>
            <v-text-field
              v-model="item.name"
              :rules="[(v) => !!v || 'Nome obrigatório']"
              class="primary-input"
              :placeholder="$t('Insira um nome para o tipo')"
              outlined
              hide-details="auto"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <span class="text ml-1">{{ $t('Unidade') }}</span>
            <v-select
              :items="unitys"
              v-model="item.unity"
              class="primary-input"
              outlined
              hide-details="auto"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-form>

      <div class="d-flex justify-end">
        <v-btn class="secondary-button ml-2 mt-6" depressed @click="openAdd">
          {{ $t('Cadastrar ponto') }}
        </v-btn>
      </div>

      <v-data-table
        :headers="headers"
        :items="item.consumptionPoints"
        class="main-table mx-4"
        hide-default-footer
        hide-default-header
      >
        <template #header="{ props, on }">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in props.headers"
                :key="header.value"
              >
                <v-simple-checkbox
                  v-if="header.value === 'data-table-select'"
                  v-model="props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  color="purple"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>

                <div>
                  <v-hover v-slot="{ hover }">
                    <div>
                      <span>{{ $t(header.text) }}</span>
                      <v-icon
                        v-if="
                          hover &&
                          header.value != 'data-table-select' &&
                          header.value != 'actions'
                        "
                        color="white"
                        class="mx-2"
                        @click="on.sort(header.value)"
                      >
                        {{
                          props.options.sortBy.includes(header.value)
                            ? `mdi-chevron-down`
                            : `mdi-chevron-up`
                        }}
                      </v-icon>
                    </div>
                  </v-hover>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #[`item.name`]="{ item }">
          <span> {{ item.name + ' / ' + item.unidade.name }} </span>
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn
                class="ma-1"
                color="#0F3565"
                dark
                small
                depressed
                @click="openEdit(item)"
                v-on="on"
              >
                <v-icon size="22">mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Editar') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn
                class="ma-1"
                color="#921616"
                depressed
                small
                @click="openDelete(item)"
                v-on="on"
              >
                <v-icon size="22">mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Excluir') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <div class="d-flex justify-end mt-4">
        <v-btn
          @click="submit"
          :loading="loading"
          class="primary-button"
          depressed
        >
          {{ isEditing ? $t('Atualizar') : $t('Cadastrar') }}
        </v-btn>
      </div>
    </v-card>

    <v-dialog v-model="deleteDialog" max-width="350">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir o item') }}
            {{ currentItem.name }}?
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            @click="deletePoint(currentItem)"
            text
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>
    <v-dialog v-model="editDialog" persistent max-width="400">
      <v-card class="pa-4">
        <h2 class="text-center">{{ $t('Editar ponto de consumo') }}</h2>

        <v-form ref="form2" class="mt-4 px-3">
          <v-text-field
            v-model="point.name"
            class="primary-input"
            :placeholder="$t('Insira um nome')"
            :rules="[(v) => !!v || 'Ponto de consumo obrigatório']"
            outlined
            hide-details="auto"
          ></v-text-field>

          <v-autocomplete
            loading="unidadeLoading"
            :items="unidades"
            item-text="name"
            item-value="id"
            v-model="point.unidadeId"
            class="primary-input"
            :placeholder="$t('Selecione a unidade')"
            :rules="[(v) => !!v || 'Unidade obrigatório']"
            outlined
            hide-details="auto"
          ></v-autocomplete>

          <v-autocomplete
            loading="unidadeLoading"
            :items="[
              { name: 'Soma', value: 0 },
              { name: 'Subtração', value: 1 },
            ]"
            item-text="name"
            item-value="value"
            v-model="point.measurementMethodology"
            class="primary-input"
            :placeholder="$t('Metodologia de medição')"
            :rules="[(v) => v != null || 'Metodologia obrigatório']"
            outlined
            hide-details="auto"
          ></v-autocomplete>
        </v-form>

        <div class="d-flex justify-center">
          <v-btn
            depressed
            class="primary-button ma-1"
            width="45%"
            @click="editDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>
          <v-btn
            depressed
            width="45%"
            class="secondary-button ma-1"
            @click="updatepoint(point)"
          >
            {{ $t('Salvar') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'

export default {
  name: 'TypeManage',

  data() {
    return {
      addPointModalKey: false,
      unidades: [],
      editDialog: false,
      addPointModal: false,
      deleteDialog: false,
      point: {
        name: null,
        unidadeId: null,
      },
      currentItem: [],
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Nome',
          align: 'center',
          value: 'name',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      pointValidate: false,
      pointName: '',
      selectedUnits: [],
      tab: 0,
      loading: false,
      isEditing: false,
      unidLoading: false,
      institutions: [],
      instLoading: false,
      institutionId: null,
      item: {
        institutionId: null,
        name: '',
        unity: 0,

        consumptionPoints: [],
      },
      user: {},
      institution: {},
      unitys: [
        { text: 'L (litros)', value: 0 },
        { text: 'M3 (Metros cubicos)', value: 1 },
        { text: 'KWh (Quilowatt)', value: 2 },
        { text: 'Kg (Quilograma)', value: 3 },
        { text: 'MWh (Megawatt)', value: 4 },
      ],
      apiService: new ApiService(),
      count: 1,
      unidadeLoading: false,
    }
  },

  async created() {
    // this.getInstitutions()

    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.item.institutionId = this.institution.id

    await this.getUnidades()

    if (this.$route.query.id) {
      await this.getItem(this.$route.query.id)

      this.isEditing = true
    }
  },

  methods: {
    openAdd() {
      if (this.$refs.form.validate()) {
        this.point.name = null
        this.point.unidadeId = null
        this.addPointModalKey = !this.addPointModalKey

        this.addPointModal = true
      }
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    deletePoint(item) {
      if (item.index) {
        this.item.consumptionPoints = this.item.consumptionPoints.filter(
          (x) => x.index !== item.index
        )
      } else {
        this.item.consumptionPoints = this.item.consumptionPoints.filter(
          (x) => x.id !== item.id
        )
      }
      this.pointValidate = true
      this.submit()

      this.deleteDialog = false
    },

    updatepoint(item) {
      if (this.$refs.form2.validate()) {
        if (item.index) {
          this.item.consumptionPoints = this.item.consumptionPoints.map((x) => {
            if (x.index === item.index) {
              x.name = item.name
            }

            return x
          })
        } else {
          this.item.consumptionPoints = this.item.consumptionPoints.map((x) => {
            if (x.id === item.id) {
              x.name = item.name
            }

            return x
          })
          this.pointValidate = true
          this.submit()
        }

        this.editDialog = false
      }
    },

    openDelete(item) {
      this.currentItem = item

      this.deleteDialog = true
    },

    openEdit(item) {
      this.point = item
      this.editDialog = true
    },

    async getItem(id) {
      this.loading = true
      await this.apiService
        .get(`consumptiontype/${id}`)
        .then((response) => {
          this.item = { ...response.content }
          this.item.unityValue = this.item.totalValue.toFixed(2)
        })
        .catch(() => {
          this.loading = false
        })
    },

    addPoint() {
      if (this.$refs.form2.validate()) {
        this.point.index = this.count
        this.count = this.count + 1

        if (this.isEditing) {
          this.point.consumptionTypeId = parseInt(this.$route.query.id)
        }

        this.item.consumptionPoints.push(this.point)
        this.pointValidate = true
        this.submit()
      }
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        if (this.isEditing) {
          await this.apiService
            .put(`consumptiontype`, this.item)
            .then(() => {
              this.$toast.success(this.$t('Tipo atualizado com sucesso!'))
              if (this.pointValidate) {
                this.getItem(this.item.id)
              } else {
                this.$router.push('/consumption')
              }

              this.addPointModal = false
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          await this.apiService
            .post(`consumptiontype`, this.item)
            .then((response) => {
              this.$toast.success(this.$t('Tipo adicionado com sucesso!'))

              if (this.pointValidate) {
                this.getItem(response.content)
                this.isEditing = true
              } else {
                this.$router.push('/consumption')
              }
              this.addPointModal = false
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
        this.pointValidate = false
      }
    },
  },

  watch: {
    institution(nv) {
      this.item.institutionId = nv.id
    },
  },
}
</script>

<style scoped>
.card {
  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.25) !important;
  border-radius: 10px;
}
</style>
